var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go_home_box",on:{"click":_vm.goToHome}},[_c('div',{staticClass:"go_home_btn"},[_vm._v(" 主页 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }